module.exports = __webpack_public_path__ + "d99fead36b3741ba74f42ccd9cd84855.MP3";